<template>
    <v-container>

        <v-row class="d-flex justify-center pt-16">
            <v-col  lg="10" md="6" sm="12">
                <v-card class="elevation-6">
                    <v-card-text>
                        <v-toolbar :class="`block-t-xl`" text light  justify="center" color="primary">
                            <v-list-item-title class="white--text">
                                <v-icon large class="mr-2"  color="white">mdi-account</v-icon><h3>Στοιχεία λογαριασμού</h3>
                            </v-list-item-title>
                        </v-toolbar>

                        <v-divider></v-divider>
                        <v-row class="d-flex pa-0 ma-0 pt-1">
                            <v-col style="height: 80px" class="col-class" cols="4"><v-icon large>mdi-library</v-icon><p>Όνομα</p></v-col>
                            <v-col style="height: 80px" class="col-class pt-6" cols="8"><p>{{$store.getters.homePageInformation.name}}</p></v-col>
                        </v-row>

                        <v-row class="d-flex pa-0 ma-0 pt-1">
                            <v-col style="height: 80px" class="col-class" cols="4"><v-icon large>mdi-account-star</v-icon><p>Διευθύνων</p></v-col>
                            <v-col style="height: 80px" class="col-class pt-6" cols="8"><p>{{$store.getters.homePageInformation.directorName}}</p></v-col>
                        </v-row>

                        <v-row class="d-flex pa-0 ma-0 pt-1">
                            <v-col style="height: 80px" class="col-class" cols="4"><v-icon large>mdi-sign-direction</v-icon><p>Διεύθυνση</p></v-col>
                            <v-col style="height: 80px" class="col-class pt-6" cols="8"><p>{{$store.getters.homePageInformation.address}}, {{$store.getters.homePageInformation.zipcode}}  {{$store.getters.homePageInformation.city}}</p></v-col>
                        </v-row>

                        <v-row class="d-flex pa-0 ma-0 pt-1">

                            <v-col style="height: 80px" class="col-class" cols="4"><v-icon large>mdi-email</v-icon><p>E-mail</p></v-col>
                            <v-col style="height: 80px" class="col-class pt-6" cols="8"><p>{{$store.getters.homePageInformation.email}}</p></v-col>
                        </v-row>

                        <v-row class="d-flex pa-0 ma-0 pt-1">
                            <v-col style="height: 80px" class="col-class" cols="4"><v-icon large>mdi-clock</v-icon><p>Ώρες Λειτουργίας</p></v-col>
                            <v-col style="height: 80px" class="col-class pt-6" cols="8"><p>{{$store.getters.homePageInformation.openingHours}}</p></v-col>
                        </v-row>

                        <v-row class="d-flex pa-0 ma-0 pt-1">
                            <v-col style="height: 80px" class="col-class" cols="4"><v-icon large> mdi-school</v-icon><p>Ίδρυμα</p></v-col>
                            <v-col style="height: 80px" class="col-class pt-6" cols="8"><p>{{$store.getters.homePageInformation.institution}}</p></v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "Homepage",
        data: () =>({

        }),

        methods:{
            returnUserRole(){
                switch(this.$store.getters.homePageInformation.pricingCommittee.authorizationId){
                    case 2:
                        return 'Διαχειριστής';
                    case 1:
                        return 'Απλός';
                    case 0:
                        return '';

                }
            },
        }
    }
</script>

<style scoped>
    .col-class{
        font-size: medium;
        font-weight: bold
    }
</style>